import { useState } from 'react';

const API = '/api';

function CampoPassword({ label: labelText, value, onChange, labelStyle, inputStyle }) {
  const [visible, setVisible] = useState(false);
  return (
    <div style={{ marginBottom: 12 }}>
      <label style={labelStyle}>{labelText}</label>
      <div style={{ position: 'relative' }}>
        <input
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          style={{ ...inputStyle, paddingRight: 36 }}
        />
        <button
          type="button"
          onClick={() => setVisible(v => !v)}
          title={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          style={{
            position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)',
            background: 'none', border: 'none', cursor: 'pointer', fontSize: 16,
            padding: 4, lineHeight: 1, color: '#4b5563',
          }}
        >
          {visible ? '🙈' : '👁️'}
        </button>
      </div>
    </div>
  );
}

export default function MiUsuario({ usuarioActual }) {
  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNuevo, setPasswordNuevo] = useState('');
  const [passwordConfirmar, setPasswordConfirmar] = useState('');
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');

    if (!passwordActual || !passwordNuevo || !passwordConfirmar) {
      setError('Todos los campos son requeridos');
      return;
    }
    if (passwordNuevo.length < 6) {
      setError('El nuevo password debe tener al menos 6 caracteres');
      return;
    }
    if (passwordNuevo !== passwordConfirmar) {
      setError('El nuevo password y su confirmación no coinciden');
      return;
    }

    setLoading(true);
    try {
      const r = await fetch(`${API}/mi-perfil/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password_actual: passwordActual, password_nuevo: passwordNuevo }),
      });
      const data = await r.json();
      if (!r.ok) {
        setError(data.error || 'Error al actualizar el password');
        return;
      }
      setMensaje('Password actualizado correctamente');
      setPasswordActual('');
      setPasswordNuevo('');
      setPasswordConfirmar('');
    } catch {
      setError('Error de conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };

  const input = { width: '100%', padding: 8, boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 4 };
  const label = { display: 'block', marginBottom: 4, fontSize: 13, color: '#4b5563' };

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ color: '#1a3a6e', marginBottom: 16 }}>Mi Usuario</h2>
      <form onSubmit={submit} style={{ background: 'white', padding: 24, borderRadius: 8, width: 340, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <div style={{ marginBottom: 16, fontSize: 14, color: '#374151' }}>
          <strong>{usuarioActual?.nombre_completo || usuarioActual?.usuario}</strong> ({usuarioActual?.usuario})
        </div>
        <h3 style={{ marginTop: 0, marginBottom: 12, fontSize: 15, color: '#1a3a6e' }}>Cambiar contraseña</h3>
        {error && <div style={{ color: '#dc2626', marginBottom: 12, fontSize: 14 }}>{error}</div>}
        {mensaje && <div style={{ color: '#16a34a', marginBottom: 12, fontSize: 14 }}>{mensaje}</div>}
        <CampoPassword label="Contraseña actual" value={passwordActual} onChange={e => setPasswordActual(e.target.value)} labelStyle={label} inputStyle={input} />
        <CampoPassword label="Contraseña nueva" value={passwordNuevo} onChange={e => setPasswordNuevo(e.target.value)} labelStyle={label} inputStyle={input} />
        <div style={{ marginBottom: 4 }}>
          <CampoPassword label="Confirmar contraseña nueva" value={passwordConfirmar} onChange={e => setPasswordConfirmar(e.target.value)} labelStyle={label} inputStyle={input} />
        </div>
        <button disabled={loading} type="submit" style={{ width: '100%', padding: 10, marginTop: 12, backgroundColor: '#1a3a6e', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 'bold' }}>
          {loading ? 'Guardando...' : 'Actualizar contraseña'}
        </button>
      </form>
    </div>
  );
}
